import { render, staticRenderFns } from "./IconTeacherLight.vue?vue&type=template&id=8a2c0f28&"
import script from "./IconTeacherLight.vue?vue&type=script&lang=js&"
export * from "./IconTeacherLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports